import { Dayjs } from 'dayjs'
import { PRIVATE_DOMAIN_BILLING_CYCLE } from '.'

export const calculateStatementDates = (
    startDate: Dayjs,
    statementOption: string
) => {
    if (statementOption === 'beginning_of_month') {
        // Đầu tháng -> cuối tháng
        const statementStartDate = startDate?.startOf('month')
        const statementEndDate = startDate?.endOf('month')
        return {
            statement_startdate: statementStartDate,
            statement_enddate: statementEndDate,
        }
    } else if (statementOption === 'day_23_to_22') {
        // Option đối soát từ ngày 23 -> 22
        if (startDate.date() >= 23) {
            // Ngày >= 23
            const statementStartDate = startDate
            const statementEndDate = startDate.add(1, 'month').set('date', 22)
            return {
                statement_startdate: statementStartDate,
                statement_enddate: statementEndDate,
            }
        } else {
            // Ngày < 23
            const statementStartDate = startDate
            const statementEndDate = startDate.set('date', 22)
            return {
                statement_startdate: statementStartDate,
                statement_enddate: statementEndDate,
            }
        }
    }
}

// Parameters are in natural (start, end) order. They used to be declared
// (end, start), which read backwards and was in fact called the wrong way round
// by initServiceTimes below — that produced a continue window starting the day
// after the period *started* and ending in the past, which the backend then
// billed as a zero-amount renewal.
export const calculateServiceTimes = (
    first_startdate: Dayjs,
    first_enddate: Dayjs
) => {
    if (!first_enddate || !first_startdate) return {}
    const temp_enddate = first_enddate.add(1, 'day')
    // A first period shorter than a month yields diff = 0, which would make the
    // renewal end the day before it starts. Renew for a month in that case.
    const diff = Math.max(1, temp_enddate.diff(first_startdate, 'month'))

    const continue_startdate = first_enddate.add(1, 'day')
    const continue_enddate = continue_startdate
        .add(diff, 'month')
        .subtract(1, 'day')

    return {
        continue_startdate,
        continue_enddate,
    }
}

// The first billing period always ends on the last day of a month, so every
// later cycle lands on calendar months. Registering on the 1st bills whole
// months; registering mid-month bills the remainder plus the whole next month.
//
// commitmentMonths mirrors the largest configoption commitment_time, so a
// 2-month commitment produces a 2-month first period. The anchor is the chosen
// start date — deriving it from "today" instead is what left the end date stale
// whenever the service was scheduled to start in a different month.
export const defaultFirstEnddate = (
    first_startdate: Dayjs,
    commitmentMonths = 1
) => {
    const months = Math.max(1, Math.floor(commitmentMonths))
    const startsOnFirstOfMonth = first_startdate.isSame(
        first_startdate.startOf('month'),
        'day'
    )
    return first_startdate
        .startOf('month')
        .add(startsOnFirstOfMonth ? months : months + 1, 'month')
        .subtract(1, 'day')
}

export const initServiceTimes = (today: Dayjs, enddate?: Dayjs) => {
    const first_startdate = today
    const first_enddate = enddate ? enddate : defaultFirstEnddate(today)

    const serviceTimes = calculateServiceTimes(first_startdate, first_enddate)

    return {
        continue_enddate: null,
        continue_startdate: null,
        ...serviceTimes,
        first_startdate,
        first_enddate,
        renew_range: 14,
        statement: 'beginning_of_month',
        statement_enddate: null,
        statement_startdate: null,
        current_enddate: null,
        current_startdate: null,
    }
}

export const getTimeRegister = (domain_registrationperiod: string) => {
    return (
        PRIVATE_DOMAIN_BILLING_CYCLE?.find(
            (item) => item.value === domain_registrationperiod
        )?.number || 0
    )
}
